import keyMirror from 'keymirror';

export default keyMirror({
  LOGIN_USER: null,
  LOGOUT_USER: null,
  LOGIN_USER_ERROR: null
});



// WEBPACK FOOTER //
// ./src/constants/AuthConstants.js